import React, { useEffect} from 'react';
import styles from '../styles/pageChangeMobileTop.module.css';

function PageChange({ currentCategory, currentPage, setCurrentPage }) {
  // Function to handle clicking on pagination buttons
  const handlePageClick = (newPage) => {
    setCurrentPage(newPage);
  };


    useEffect(() => {   
    }, [currentCategory, currentPage]);

        
    return (
      <div className={styles['pagination-controls']}>
        <button
          className={styles['pagination-button']}
          onClick={() => handlePageClick(1)}
          disabled={currentPage === 1}
        >
          First
        </button>
        {Array.from({ length: 5 }, (_, index) => {
          const page = currentPage - 2 + index;
          if (page > 0) {
            return (
              <button
                key={page}
                className={`${styles['pagination-button']} ${
                  page === currentPage ? styles['current-page'] : ''
                }`}
                onClick={() => handlePageClick(page)} // Update the page on click
              >
                {page}
              </button>
            );
          }
          return null;
        })}
        <button
          className={styles['pagination-button']}
          onClick={() => handlePageClick(currentPage + 1)} // Update the page on click
        >
          Next
        </button>
      </div>
    );
  }
export default PageChange;